module.exports = __webpack_public_path__ + "static/fontello-33f014d4d3d44e99bbc57eb2989e2051.eot";